"use strict";

import angular from "angular";

import template from "./sidenav-accountings.component.html";
import "./themes/sidenav-accountings.component.scss";
import "./themes/sidenav-accountings.component-dark.scss";

import { User } from "../../../gateway/User/User";
import { HubSpot } from "../../../presentation/services/HubSpot/HubSpot";
import { ConsultiveAccessService } from "../../../presentation/services/ConsultiveAccessService";
import { HomeRedirectService } from "../../../presentation/services/HomeRedirectService";
import toastCustomTemplate from "../nu-toast-custom/toast-custom.component.html";
import chartScoreAccountingsDialogTemplate from "../../../views/accountings/dialogs/chart-score-accountings/chart-score-accountings-dialog.html";

export class SideNavAccountingsComponent {
    constructor($scope, $mdSidenav, toast, LoaderService, DesnuDialogService) {
        this.$scope = $scope;
        this.$mdSideNav = $mdSidenav;
        this.toast = toast;
        this.LoaderService = LoaderService;
        this.DesnuDialogService = DesnuDialogService;

        this.User = new User();
        this.HubSpot = new HubSpot();
    }

    $onInit() {}

    /**
     * O painel abre para UMA contabilidade, então dá para resolver o acesso dela aqui e o rótulo
     * do link dizer a verdade. Na listagem, com muitas linhas, isso não se paga — lá o rótulo é
     * neutro e o acesso é resolvido só no clique.
     */
    async $onChanges(changes) {
        if (!changes?.data) return;
        const accountingId = this.data?.props?._id;
        this.hasConsultiveAccess = accountingId
            ? await ConsultiveAccessService.resolveFor({ accountingId })
            : false;
        this.homeLabel = HomeRedirectService.getLabel(
            this.hasConsultiveAccess
        );
        this.$scope.$applyAsync();
    }

    /**
     * Abre a casa da contabilidade DO CLIENTE: Central Consultiva ou Carteira.
     *
     * O acesso é resolvido na hora, pela contabilidade e pelo plano dela — o `peek()` responderia
     * pelo nuconter logado, e o campo da linha só conhece o override.
     */
    async onOpenCentralConsultiva() {
        const accountingId = this.data?.props?._id;
        if (!accountingId) return;

        const hasAccess =
            this.hasConsultiveAccess ??
            (await ConsultiveAccessService.resolveFor({ accountingId }));
        window.open(
            HomeRedirectService.getUrl({ accountingId, hasAccess }),
            "_blank"
        );
    }

    onShowHistoricScore() {
        this.DesnuDialogService.custom({
            controller: "ChartScoreAccountingsCtrl",
            controllerAs: "$ctrl",
            clickOutsideToClose: true,
            locals: {
                accountingData: this.data.props,
                width: "600px",
                templateHtml: chartScoreAccountingsDialogTemplate,
                title: "Score"
            },
            after: {}
        });
    }

    onClose() {
        this.$mdSideNav(this.componentId).toggle();
    }

    _showToastUpdate(message) {
        this.toast.show("", "bottom right", {
            hideDelay: 1000,
            controllerAs: "ctrl",
            locals: {
                toastMessage: message,
                action: [
                    {
                        style: "md-icon-button desnu-button-icon desnu-button-small",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }

    async onInsertHubspot(customer, targetEvent) {
        this.DesnuDialogService.confirmation({
            targetEvent,
            locals: {
                title: "Tem certeza que deseja reenviar?",

                actions: {
                    confirm: {
                        label: "Reenviar",
                        action: async () => {
                            this.DesnuDialogService.hide();
                            this.loading = true;
                            try {
                                await this.HubSpot.insert(customer._id);

                                this.$scope.$applyAsync();

                                this._showToastUpdate(
                                    "Contabilidade cadastrada com sucesso"
                                );
                            } catch (err) {
                                this._showToastUpdate(
                                    "Não foi possivel cadastrar esta contabilidade"
                                );
                            }
                            this.loading = false;
                        }
                    },
                    cancel: {
                        label: "Cancelar",
                        action: () => {
                            this.DesnuDialogService.cancel();
                        }
                    }
                }
            },
            after: {
                hide: () => {},
                cancel: () => {}
            }
        });
    }
}

SideNavAccountingsComponent.$inject = [
    "$scope",
    "$mdSidenav",
    "toast",
    "LoaderService",
    "DesnuDialogService"
];

const name = "sideNavAccountingsComponent";
const def = {
    bindings: {
        data: "<",
        componentId: "@",
        showResend: "=",
        showSeller: "=",
        showCs: "=",
        showRelationship: "=",
        showHubspot: "=",
        showCnpj: "=",
        showPersona: "=",
        showUpdateAccounting: "=",
        showFinancial: "=",
        showOrigin: "="
    },
    controller: SideNavAccountingsComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
